import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import { Model, Nullable, Ordenable } from './Model';
import { Question } from './Question';

export default interface Activity extends Model, Ordenable {
  name: string;
  type?: ActivityBlockType;
  activityType?: ActivityBlockType;
  questions: Question[];
  author: number;
  inBank: boolean;
  isPublicInBank: boolean;
  isActive?: boolean;
  status: VersioningStatusEnum;
  shuffleQuestions: boolean;
  timeLimit: Nullable<number>;
}

export enum ActivityBlockType {
  REGULAR = 'REGULAR',
  MANUAL_GRADE = 'MANUAL_GRADE',
  OPTIONAL = 'OPTIONAL',
  CONSOLIDATION = 'CONSOLIDATION',
}
